import { Button, Clickable, SpacerWrapper } from '@ahmdigital/ui';
import styled from 'styled-components';

export const StyledWrapper = styled(SpacerWrapper)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 4.5rem;
  border-top: ${({ theme }) => `1px solid ${theme.colors.grey20}`};

  @media (min-width: ${({ theme }) => theme.media.md}) {
    flex-direction: row;
    position: relative;
  }
`;

export const StyledButton = styled(Button)`
  margin: 0 auto 1rem;
  width: 100%;
  font-size: 1rem;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin: 0;
    width: auto;
  }
`;

export const StyledClickable = styled(Clickable)`
  margin-bottom: 1rem;
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  font-size: 0.875rem;

  @media (min-width: ${({ theme }) => theme.media.md}) {
    margin-bottom: 0;
  }
`;

export const ForwardButtonsWrapper = styled.div`
  display: flex;
  gap: 2.5rem;
  right: 0;
  position: absolute;
`;
